export interface GeocoderResponse {
    results: GeocoderResult[]
}

export interface GeocoderResult {
    address_components: GeocoderAdressComponent[];
    formatted_address: string;
    geometry: GeocoderGeometry;
    place_id: string;
    types: GeocoderResultType[];
}

export interface GeocoderAdressComponent {
    long_name : string;
    short_name: string;
    types: GeocoderAdressComponentTypeEnum[];
}

export enum GeocoderAdressComponentTypeEnum {
    STREET_NUMBER = 'street_number',
    ROUTE = 'route',
    NEIGHBORHOOD = 'neighborhood',
    POLITICAL = 'political',
    SUBLOCALITY = 'sublocality',
    ADMINISTRATIVE_LEVEL_1 = 'administrative_area_level_1',
    ADMINISTRATIVE_LEVEL_2 = 'administrative_area_level_2',
    ADMINISTRATIVE_LEVEL_3 = 'administrative_area_level_3',
    LOCALITY = 'locality',
    COUNTRY = 'country',
    POSTAL_CODE = 'postal_code'
}

export enum GeocoderResultType {
    STREET_ADDRESS = "street_address",
}

export interface GeocoderGeometry {
    location: LatLng,
    location_type: string;
    viewport: GeocoderGeometryViewport,
}

export interface GeocoderGeometryViewport {
    northeast: LatLng,
    southwest: LatLng
}

export type LatLng = { lat: number, lng: number };